import { render, staticRenderFns } from "./GroupMemberDialog.vue?vue&type=template&id=2b7bf8b6&scoped=true"
import script from "./GroupMemberDialog.vue?vue&type=script&lang=js"
export * from "./GroupMemberDialog.vue?vue&type=script&lang=js"
import style0 from "./GroupMemberDialog.vue?vue&type=style&index=0&id=2b7bf8b6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b7bf8b6",
  null
  
)

export default component.exports